import { h as head, b as attr, p as pop, a as push } from "../../../../../chunks/index2.js";
import "@sveltejs/kit/internal";
import "../../../../../chunks/exports.js";
import "../../../../../chunks/utils.js";
import "../../../../../chunks/state.svelte.js";
function _page($$payload, $$props) {
  push();
  let { data, form } = $$props;
  let name = data.category?.name || "";
  let id = data.category?.id || "";
  head($$payload, ($$payload2) => {
    $$payload2.title = `<title>Edit Category</title>`;
  });
  $$payload.out.push(`<div class="container mx-auto p-6"><div class="mb-6 space-y-5"><div class="flex items-center space-x-4"><a href="/admin/category" class="rounded-md bg-gray-100 px-4 py-2 text-gray-600 transition-colors hover:bg-gray-200">← Back to Categories</a> <h1 class="text-3xl font-bold">Edit Category</h1></div> `);
  if (!data.category) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<p class="text-center text-sm text-gray-500">Category not found</p>`);
  } else {
    $$payload.out.push("<!--[!-->");
    $$payload.out.push(`<form method="POST" class="rounded-lg bg-white p-6 shadow-sm">`);
    {
      $$payload.out.push("<!--[!-->");
    }
    $$payload.out.push(`<!--]--> <div class="mb-4"><label for="name" class="mb-1 block text-sm font-medium text-gray-700">Category Name</label> <input id="name" type="text" name="name"${attr("value", name)} class="focus:ring-primary w-full rounded-lg border px-3 py-2 focus:ring-1 focus:outline-hidden" required/></div> <input type="hidden" name="id"${attr("value", id)}/> <button type="submit" class="bg-primary hover:bg-primary/90 rounded-lg px-4 py-2 text-white">Save Changes</button></form>`);
  }
  $$payload.out.push(`<!--]--></div></div>`);
  pop();
}
export {
  _page as default
};
